<template>
  <b-modal
    v-model="modal"
    class="position-relative"
    lazy
    centered
    body-class="py-5"
    content-class="new-section-modal"
    size="lg"
    hide-footer
    hide-header
  >
    <h3 class="text-center font-weight-bold mb-12 px-0">
      Move Global Variable to Folder
    </h3>

    <b-row>
      <b-col
        offset="2"
        cols="8"
      >
        <b-form @submit.prevent="submit">
          <b-form-group
            class="estage-form-group"
            label="Folder"
            label-class="font-medium"
          >
            <v-select
              v-model="folder"
              :options="[
                {
                  key: null,
                  name: 'Root'
                },
                ...folders
              ]"
              :reduce="option => option.key"
              label="name"
              placeholder="Root"
            />
          </b-form-group>

          <div class="text-center mt-5">
            <b-btn
              type="submit"
              variant="primary"
              class="font-weight-bold font-size-14 px-5"
              :disabled="loading"
            >
              Move to Folder
              <b-spinner
                v-if="loading"
                class="mr-2"
                variant="light"
                small
              />
            </b-btn>
          </div>
        </b-form>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'GlobalVariableMoveToFolder',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    variables: {
      type: Array,
      required: false,
      default: () => []
    },
    folders: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    modal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
      folder: null,
      loading: false
    }
  },
  watch: {
    modal (val) {
      if (val) {
        this.folder = this.variables[0].folder
        this.loading = false
      }
    }
  },
  methods: {
    submit () {
      this.$emit('submit', this.variables, this.folder)
      this.modal = false
    }
  }
}
</script>
